import React, { useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import '../style/ContactForm.css';

const MainKYC = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    passportFront: null,
    passportBack: null,
    selfie: null,
  });

  const updateFormData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  // Внутри компонента MainKYC
const submitForm = async () => {
  setLoading(true);
  setMessage("");

  try {
    const data = new FormData();
    
    // ВАЖНО: Ключи должны совпадать с контроллером бэкенда
    data.append("fullName", formData.name); // Бэкенд ждет fullName
    data.append("email", formData.email);
    
    // Файлы должны совпадать с именами в multer config:
    // passport_front, passport_back, selfie
    if (formData.passportFront) {
      data.append("passport_front", formData.passportFront);
    }
    if (formData.passportBack) {
      data.append("passport_back", formData.passportBack);
    }
    if (formData.selfie) {
      data.append("selfie", formData.selfie);
    }

    const response = await fetch("https://bilpay.kg/api/kyc", {
      method: "POST",
      body: data,
      // Заголовок Content-Type для FormData ставить НЕ НУЖНО, 
      // браузер установит его сам вместе с boundary
    });

    const result = await response.json();

    if (result.success) {
      setMessage(`✅ ${result.message}`);
      // Можно перенаправить пользователя или очистить форму
    } else {
      setMessage(`❌ Ошибка: ${result.error}`);
    }
  } catch (error) {
    console.error("Ошибка при отправке:", error);
    setMessage("❌ Ошибка соединения с сервером. Попробуйте позже.");
  } finally {
    setLoading(false);
  }
};

  const sidebarTexts = {
    1: "Напишите как к вам обращаться и на какую почту отправить логин и пароль для входа в личный кабинет",
    2: "Тут необходимо загрузить фотографию вашего паспорта, с обеих сторон. Это нужно лишь для вашей идентификации.",
    3: "Сделайте четкое селфи, удерживая паспорт рядом с лицом, чтобы завершить процесс."
  };

  return (
    <div className="page-wrapper" style={{display: "flex", justifyContent: "center"}}> 
      <div className="form-container">
        <div className="sidebar">
          <div className="sidebar-top">
            <div className="logo-circle">B</div>
            <div className="user-meta" style={{display: 'flex', flexDirection: 'column'}}>
              <div className="brand-name">Bil Pay</div>
              <div className="brand-phone">+996 708 333 333</div>
            </div>
          </div>
          
          <div className="sidebar-content">
            <p className="sidebar-text">{sidebarTexts[step]}</p>
          </div>

          <div className="sidebar-footer">
            Заявки будут рассмотрены при подтверждении документов.
          </div>
        </div>

        <div className="main-content">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${(step / 3) * 100}%` }}></div>
          </div>

          <div className="step-container">
            {step === 1 && (
              <Step1 
                formData={formData} 
                updateFormData={updateFormData} 
                nextStep={() => setStep(2)} 
              />
            )}
            {step === 2 && (
              <Step2 
                formData={formData} 
                updateFormData={updateFormData} 
                nextStep={() => setStep(3)} 
                prevStep={() => setStep(1)} 
              />
            )}
            {step === 3 && (
              <Step3 
                formData={formData} 
                updateFormData={updateFormData}
                prevStep={() => setStep(2)}
                submitForm={submitForm}
                loading={loading}
                message={message}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainKYC;